<template>
	<v-card
		ref="projectsPanel"
		:height="actualFillHeight"
		color="brightBackground"
		flat
		tile
		v-resize="onResize"
	>
		
		<v-container fluid style="max-width: 1000px;" class="pt-xs-0 pt-sm-0 pt-md-0 pt-lg-6">

			<v-row>

				<v-col align="center" justify="center">
					
					<v-subheader class="display-1 font-weight-bold ml-0 pl-1 pb-0 mb-4" style="color: #4e1e1e;">Disabled projects</v-subheader>

					<!-- Clients listed -->
					<v-card
						v-for="client in filteredDataProvider" :key="client.name"
						color="boxOnBrightBackground"
						flat
						class="pa-3 mb-4 pb-1"
					>


						<div align="left" class="title primary--text text--darken-3 pb-2">{{client.name}}</div>


						<!-- Project groups listed -->
						<v-card
							v-for="(group, j) in client.groups" :key="j"
							color="boxOnBrightBackground"
							flat
							
						>
							<div align="left" class="subtitle-1 primary--text text--darken-3 pb-1 pt-1">{{ group.name }}</div>


							<!-- -------------------------------------------- -->
							<!--   Expansion panel (Projects) -->
							<!-- -------------------------------------------- -->

							<v-expansion-panels multiple class="pb-3">

								<v-expansion-panel v-for="(project, i) in group.projects" :key="i">
									
									<!-- Expanded panel header-->
									<v-expansion-panel-header color="grey lighten-4 primary--text text--darken-1">
										<b>{{ project.name }}</b>
									</v-expansion-panel-header>

									<!-- Expanded panel -->
									<v-expansion-panel-content>
										<v-container fluid class="pt-4 pb-0 px-1">

											<v-row>
												<v-col align="left">
													<!-- <v-btn style="text-transform: none;" class="mr-3" small text @click="reenableProject(project)">
														<v-icon medium class="pr-1">mdi-backup-restore</v-icon>
														Re-enable project
													</v-btn>
													<v-btn style="text-transform: none;" class="mr-3" small text @click="deleteProject(project)">
														<v-icon medium class="pr-1">mdi-delete</v-icon>
														Permanently delete project
													</v-btn> -->
													
													<icon-text-button b-icon="mdi-backup-restore" @click="reenableProject(project)">Re-enable project</icon-text-button>
													<icon-text-button b-icon="mdi-delete" @click="deleteProject(project)">Permanently delete project</icon-text-button>
												</v-col>
											</v-row>

										</v-container>

									</v-expansion-panel-content>
								</v-expansion-panel>


							</v-expansion-panels>

						</v-card>

					</v-card>

				</v-col>
			</v-row>
			
		</v-container>

	</v-card>
</template>



<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile';
import agileFb from '@/shift/agileFb';
import fb from '@/shift/fb';

export default
{
	name: 'ProjectsDisabled',

	// ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({
		// Variable for filling the height between top toolbar and bottom
		actualFillHeight: 100,

		filteredDataProvider: [],
		clients: [],
		groups: [],
		projects: [],
		firestoreLiveConnections: [],
		
	}),

	computed:
	{
		agile()
		{
			return agile;
		},
		
		// Variable for UI height adjustment
		appBarHeight()
		{
			return agile.appBarHeight();
		},
	},


	// ----------------------------------
	//	VUE: Watching things
	// ----------------------------------

	watch:
	{
		// ----------------------------------
		//	Check if clients got its groups updated
		// ----------------------------------

		clients: function()
		{
			this.buildDataProvider();
		},

		groups: function()
		{
			this.buildDataProvider();
		},
		
		projects: function()
		{
			this.buildDataProvider();
		}
	},

	// ----------------------------------------------------
	//
	//  VUE: Create and Mount
	//
	// ----------------------------------------------------

	created()
	{

		// ----------------------------------
		//	Load client list and let it
		//  live reload!
		// ----------------------------------
		
		this.firestoreLiveConnections.push(

			fb.db.collection('clients').onSnapshot(res =>
			{
				const changes = res.docChanges();

				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						this.clients.push(
						{
							...change.doc.data(),
							id: change.doc.id
						})
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						for (let i = 0; i < this.clients.length; i++)
						{
							if (this.clients[i].id == change.doc.id)
							{
								var uD = change.doc.data();
								this.clients[i].name = uD.name;
								this.clients[i].variable = uD.variable;
								this.clients[i].prefix = uD.prefix;
								this.clients[i].id = change.doc.id;
							}
						}
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						for (let i = 0; i < this.clients.length; i++)
						{
							if (this.clients[i].id == change.doc.id)
							{
								this.clients.splice(i, 1);
							}
						}
					}
				});

				// ----------------------------------
				//	Sort alphabetically by name
				// ----------------------------------

				this.agile.sortBy(this.clients, 'name');


			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			})
		);




		// ----------------------------------
		//	Load project group list and let it
		//  live reload!
		// ----------------------------------
		
		this.firestoreLiveConnections.push(
		
			fb.db.collection('project-groups').onSnapshot(res =>
			{
				const changes = res.docChanges();

				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						this.groups.push(
						{
							...change.doc.data(),
							id: change.doc.id
						})
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						for (let i = 0; i < this.groups.length; i++)
						{
							if (this.groups[i].id == change.doc.id)
							{
								var uD = change.doc.data();
								this.groups[i].name = uD.name;
								this.groups[i].variable = uD.variable;
								this.groups[i].prefix = uD.prefix;
								this.groups[i].clients = uD.clients;
								this.groups[i].id = change.doc.id;
							}
						}
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						for (let i = 0; i < this.groups.length; i++)
						{
							if (this.groups[i].id == change.doc.id)
							{
								this.groups.splice(i, 1);
							}
						}
					}
				});

				// ----------------------------------
				//	Sort alphabetically by name
				// ----------------------------------

				this.agile.sortBy(this.groups, 'name');

			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			})
		);
		




		// ----------------------------------
		//	Load project list and let it
		//  live reload!
		// ----------------------------------
		
		this.firestoreLiveConnections.push(
		
			fb.db.collection('projects').where('disabled', '==', true).onSnapshot(res =>
			{
				const changes = res.docChanges();

				changes.forEach(change =>
				{

					// ----------------------------------
					//	Content added
					// ----------------------------------

					if (change.type === 'added')
					{
						this.projects.push(
						{
							...change.doc.data(),
							id: change.doc.id
						})
					}


					// ----------------------------------
					//	Content modified
					// ----------------------------------

					if (change.type === "modified")
					{
						for (let i = 0; i < this.projects.length; i++)
						{
							if (this.projects[i].id == change.doc.id)
							{
								var uD = change.doc.data();
								this.projects[i].name = uD.name;
								this.projects[i].variable = uD.variable;
								this.projects[i].prefix = uD.prefix;
								this.projects[i].clients = uD.clients;
								this.projects[i].id = change.doc.id;
							}
						}
					}


					// ----------------------------------
					//	Content deleted
					// ----------------------------------

					if (change.type === "removed")
					{
						for (let i = 0; i < this.projects.length; i++)
						{
							if (this.projects[i].id == change.doc.id)
							{
								this.projects.splice(i, 1);
							}
						}
					}
				});

				// ----------------------------------
				//	Sort alphabetically by name
				// ----------------------------------

				this.agile.sortBy(this.projects, 'name');

			},
			er =>
			{
				this.$root.$alert("Error", er.message);
			})
		);



	},

	mounted()
	{
		this.onResize();
	},


	// --------------------------------------------------------------------
	//
	//	VUE: Methods
	//
	// --------------------------------------------------------------------

	methods:
	{
		
		// ----------------------------------
		//	Structue group data into clients
		// ----------------------------------

		buildDataProvider()
		{
			// This function makes a tree structure of client/group/project, and only if there are projects present.
			// Probably a stupid way to do it, but it works...

			this.filteredDataProvider = new Array();

			for (let i = 0; i < this.clients.length; i++)
			{
				
				let groups = new Array();

				for (let j = 0; j < this.groups.length; j++)
				{
					if (this.clients[i].id == this.groups[j].clientId)
					{
						let projects = new Array();

						for (let k = 0; k < this.projects.length; k++)
						{
							if (this.groups[j].id == this.projects[k].groupId)
							{
								projects.push(this.projects[k]);
							}
						}

						if (projects.length > 0)
						{
							groups.push(this.groups[j]);
							this.groups[j].projects = projects;
						}
					}
				}
				
				if (groups.length > 0)
				{
					this.filteredDataProvider.push(this.clients[i]);
					this.clients[i].groups = groups;
				}
				
			}
			
		},

		
		// ----------------------------------
		//	Save client data
		// ----------------------------------
		
		reenableProject(project)
		{
			
			// Todo: Validate god damn it
			this.$root.$confirm('Careful', 'Really want to re-enable project?', { color: 'warning' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					// ----------------------------------
					//	Create client in Firebase
					// ----------------------------------

					fb.db.collection("projects").doc(project.id).update(
					{
						disabled: false
					})
					.then(() =>
					{
						this.$root.ai_app.snackbarText = 'Project re-enabled';
						this.$root.ai_app.snackbarTimeout = 3000;
						this.$root.ai_app.snackbar = true;
					})
					.catch((error) =>
					{
						this.$root.$alert("Error", error.message);
					});
				}
			});
		},


		// ----------------------------------
		//	Disable project
		// ----------------------------------

		deleteProject(project)
		{
			this.$root.$confirm('Careful', 'Deleting projects permanently are... permanent! Still want to delete?', { color: 'error' } )
			.then((confirm) =>
			{
				if (confirm)
				{
					fb.db.collection("projects").doc(project.id).delete()
					.then(() =>
					{
						this.$root.ai_app.snackbarText = 'Project permanently deleted';
						this.$root.ai_app.snackbarTimeout = 3000;
						this.$root.ai_app.snackbar = true;

						// Update security rules for path to project
						agileFb.updateSecurityRules();
						agileFb.updateUsersAccessCards();
					})
					.catch((error) =>
					{
						this.$root.$alert("Error", error.message);
					});
					
				}
			});

		},
		
		// ----------------------------------
		//	On resize call to fix layout
		// ----------------------------------

		onResize()
		{
			this.actualFillHeight =
				window.innerHeight -
				this.appBarHeight;
		},
	},


	
	// --------------------------------------------------------------------
	//
	//	VUE: Destroy event hook
	//
	// --------------------------------------------------------------------
	
	beforeDestroy()
	{
		// Unsubscribe live listeners
		for (let i = 0; i < this.firestoreLiveConnections.length; i++)
		{
			this.firestoreLiveConnections[i]();
		}
	},


}
</script>